import { Form, Success, TotalTransfer } from './components';

const TransferBetweenPortfoliosFlow = {
  Form,
  Success,
  TotalTransfer,
};

export { TransferBetweenPortfoliosFlow };
